import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';
import {
  BsTelephoneFill,
  BsWhatsapp,
  BsEnvelopeFill,
  BsGeoAltFill,
} from "react-icons/bs";

function Navimumbaiinternationalairportcab() {



const cardData = {
  keyword: " Navi Mumbai International Airport Cab",

headingDescription:
"Omshree Cab offers professional and reliable Navi Mumbai International Airport cab services for travelers looking for convenient, safe, and comfortable transportation to and from the airport. Whether you are arriving for business, leisure, or a long-distance journey, our cab service ensures a hassle-free experience with punctual pickups, well-maintained vehicles, and experienced chauffeurs. We provide a wide range of vehicles including air-conditioned sedans, spacious SUVs, luxury cars, and tempo travelers suitable for solo travelers, families, and groups. Our flexible booking options include one-way transfers, round trips, and hourly packages with transparent pricing and no hidden charges. With 24/7 customer support and easy online booking, Omshree Cab is your trusted partner for Navi Mumbai International Airport cab services.",

topPlaces: [
{
title: "Palm Beach Road",
description:
"Palm Beach Road is one of the most scenic and well-planned roads in Navi Mumbai, connecting Vashi, Nerul, and Belapur. It offers beautiful views of the waterfront, modern infrastructure, and smooth driving conditions. Traveling by cab from Navi Mumbai International Airport ensures a comfortable and convenient ride for sightseeing or commuting along this iconic route."
},
{
title: "Central Park Kharghar",
description:
"Central Park in Kharghar is a vast green space featuring landscaped gardens, walking paths, fountains, and recreational areas ideal for morning walks, picnics, and family outings. A cab from Navi Mumbai International Airport allows visitors to reach this scenic park easily and enjoy leisure time without worrying about transport or parking."
},
{
title: "Utsav Chowk",
description:
"Utsav Chowk is a famous landmark in Kharghar known for its striking architecture and decorative fountains. Visitors often stop here for photographs, dining, or casual strolls. Using a cab from Navi Mumbai International Airport provides hassle-free access and a comfortable journey to this popular city spot."
},
{
title: "Seawoods Grand Central Mall",
description:
"Seawoods Grand Central Mall is a premier shopping and entertainment destination in Navi Mumbai, featuring retail stores, restaurants, cafes, and multiplex cinemas. Travelers arriving at Navi Mumbai International Airport can reach the mall conveniently by cab, making it ideal for shopping sprees or leisure outings."
},
{
title: "Belapur Fort",
description:
"Belapur Fort is a historic site in Navi Mumbai offering insight into the region’s heritage and architecture. The fort’s scenic surroundings make it a popular spot for photography and leisurely exploration. A cab from Navi Mumbai International Airport provides an easy and comfortable way to visit this landmark."
},
{
title: "ISKCON Kharghar",
description:
"ISKCON Kharghar is a spiritual center dedicated to Lord Krishna, offering a peaceful and devotional atmosphere. Visitors can attend prayers, meditation sessions, and cultural programs. Traveling by cab from Navi Mumbai International Airport ensures a comfortable and timely arrival for devotees and tourists alike."
},
{
title: "Nerul Balaji Temple",
description:
"Nerul Balaji Temple is a prominent religious site dedicated to Lord Venkateswara, known for its South Indian architectural style and serene environment. Visitors can enjoy darshan, prayers, and spiritual experiences. A cab from Navi Mumbai International Airport provides convenient transportation to this sacred destination."
},
{
title: "Sagar Vihar",
description:
"Sagar Vihar is a scenic waterfront promenade in Vashi, offering panoramic views of Thane Creek, evening strolls, and photography opportunities. Families and couples enjoy the cool breeze and relaxed atmosphere. A cab ride from Navi Mumbai International Airport ensures a smooth and comfortable journey to this beautiful spot."
},
{
title: "Golf Course Kharghar",
description:
"The Kharghar Golf Course is a large recreational area with lush green lawns, open fields, and scenic surroundings. Visitors come here for leisure walks, outdoor activities, and photography. A cab from Navi Mumbai International Airport provides convenient access for a relaxing visit."
},
{
title: "Pandavkada Waterfalls",
description:
"Pandavkada Waterfalls is a natural attraction near Kharghar, especially popular during the monsoon season. Visitors enjoy trekking, photography, and short nature walks in a lush green setting. Traveling by cab from Navi Mumbai International Airport allows easy and comfortable access to this refreshing destination."
}
],



services: [
{
name: "Navi Mumbai International Airport Cab",
description: "Navi Mumbai International Airport cab service provides reliable airport transportation for passengers traveling to or from NMIA. Travelers can easily book comfortable sedans, SUVs, and premium vehicles for airport pickup and drop services across Navi Mumbai and nearby cities. Professional drivers ensure punctual arrival and safe driving for stress-free airport transfers. Vehicles are well maintained with spacious seating and powerful AC for comfortable journeys. The service is ideal for business travelers, tourists, and families needing dependable airport transportation. Customers enjoy smooth travel experience with timely pickups from homes, hotels, offices, and railway stations."
},
{
name: "NMIA Airport Cab Service",
description: "NMIA airport cab service offers convenient transportation solutions for passengers arriving at or departing from Navi Mumbai International Airport. The service includes comfortable sedan and SUV vehicles suitable for individual travelers and groups. Professional drivers track flight schedules to ensure timely airport pickups and drop-offs. Vehicles provide comfortable seating and luggage space for passengers traveling with bags. The cab service operates across Navi Mumbai, Mumbai, Thane, and surrounding regions. Travelers benefit from reliable transportation and easy booking options. The service ensures a safe and comfortable airport travel experience."
},
{
name: "NMIA Taxi Service Navi Mumbai",
description: "NMIA taxi service Navi Mumbai provides dependable airport taxi transportation for passengers traveling through Navi Mumbai International Airport. The service offers clean and well-maintained vehicles for comfortable airport transfers. Professional drivers ensure punctual pickup services and smooth driving throughout the journey. Travelers can use the service for both airport pickup and drop travel. The taxi provides spacious interiors and air-conditioned comfort for passengers. It is ideal for business travelers, tourists, and local commuters. The service guarantees convenient and reliable airport transportation."
},
{
name: "Cab for NMIA Airport",
description: "Cab for NMIA airport provides comfortable transportation for travelers heading to Navi Mumbai International Airport. The vehicles offer smooth driving performance and comfortable seating for passengers traveling with luggage. Professional drivers ensure timely pickup from homes, hotels, offices, and transport hubs. The service is suitable for early morning and late-night airport travel. Passengers enjoy air-conditioned comfort during their journey. The cab service provides safe and reliable airport transfers. Travelers benefit from convenient and stress-free transportation."
},
{
name: "Taxi for NMIA Airport",
description: "Taxi for NMIA airport offers reliable taxi transportation for passengers traveling to and from Navi Mumbai International Airport. The taxi provides comfortable seating and smooth ride quality for airport journeys. Professional drivers ensure punctual pickups and safe driving across Navi Mumbai locations. The service is ideal for families, tourists, and corporate travelers. Vehicles offer luggage space and air-conditioned interiors for comfortable travel. Passengers enjoy convenient airport transportation with reliable service. It ensures stress-free travel to the airport."
},
{
name: "NMIA Airport Pickup Cab",
description: "NMIA airport pickup cab provides reliable transportation for passengers arriving at Navi Mumbai International Airport. Professional drivers greet travelers at the airport and assist with luggage for comfortable travel. Vehicles provide spacious seating and strong AC cooling for relaxed rides. The pickup service is available for hotels, offices, and residential areas across Navi Mumbai. Passengers enjoy smooth travel after arriving from flights. The cab ensures safe driving and comfortable transportation. It is a convenient option for airport arrivals."
},
{
name: "NMIA Airport Drop Taxi",
description: "NMIA airport drop taxi offers convenient transportation for passengers traveling from Navi Mumbai to the airport. The taxi provides punctual pickup services ensuring travelers reach the airport on time for their flights. Professional drivers ensure safe driving and efficient route planning. Vehicles offer comfortable seating and luggage space for airport travel. The service operates throughout Navi Mumbai and nearby cities. Passengers enjoy reliable airport transportation without travel stress. It is ideal for business travelers and tourists."
},
{
name: "NMIA Airport Cab Booking",
description: "NMIA airport cab booking allows passengers to easily reserve airport taxis for convenient travel. Customers can book vehicles through phone or online platforms with quick confirmation. The vehicles offer comfortable seating and reliable ride performance. Professional drivers ensure punctual pickups and safe airport transportation. The booking service supports airport pickup and drop trips. Travelers enjoy simple and convenient reservation processes. It provides reliable transportation planning for airport journeys."
},
{
name: "NMIA Airport Taxi Booking Online",
description: "NMIA airport taxi booking online provides digital booking options for travelers planning airport transportation. Customers can easily schedule rides online with instant confirmation. The taxi service offers comfortable vehicles suitable for airport transfers. Professional drivers ensure safe driving and timely pickup services. The service is ideal for travelers who prefer convenient online reservations. Passengers enjoy reliable transportation with simple booking steps. Online booking saves time and ensures smooth travel planning."
},
{
name: "Cheap NMIA Airport Cab",
description: "Cheap NMIA airport cab service provides affordable airport transportation without compromising comfort or safety. Travelers can choose budget-friendly sedans and SUVs for economical airport travel. Vehicles provide comfortable seating and reliable ride quality. Professional drivers ensure punctual pickup services across Navi Mumbai. The service is ideal for budget travelers and daily commuters. Passengers enjoy convenient and economical transportation. It offers reliable airport travel at affordable rates."
},
{
name: "Best NMIA Airport Taxi Service",
description: "Best NMIA airport taxi service provides premium airport transportation with reliable drivers and comfortable vehicles. Travelers receive punctual pickup services and smooth ride experiences. Vehicles offer spacious seating and air-conditioned interiors for relaxed travel. The taxi service is suitable for business travelers, families, and tourists. Professional drivers ensure safe driving and courteous service. Customers enjoy dependable airport transfers across Navi Mumbai. It ensures a high-quality travel experience."
},
{
name: "24x7 NMIA Airport Cab",
description: "24x7 NMIA airport cab service provides round-the-clock transportation for travelers needing airport transfers at any time of the day. The service supports early morning and late-night travel schedules. Vehicles provide comfortable seating and reliable ride quality. Professional drivers ensure safe driving and punctual pickups across Navi Mumbai. Passengers can easily book taxis anytime for airport travel. The service ensures dependable transportation availability. Travelers enjoy flexible and convenient airport travel."
},
{
name: "NMIA Airport Innova Cab",
description: "NMIA airport Innova cab provides spacious MPV transportation ideal for families and group travelers heading to or from the airport. The Toyota Innova offers comfortable seating and excellent ride quality for airport journeys. Professional drivers ensure punctual pickup services and safe driving. Vehicles provide ample luggage space for passengers traveling with bags. The service is ideal for airport group transfers and corporate travel. Passengers enjoy premium comfort and smooth travel. It provides reliable airport transportation."
},
{
name: "NMIA Airport Sedan Taxi",
description: "NMIA airport sedan taxi provides comfortable sedan transportation for airport transfers across Navi Mumbai. Vehicles like Swift Dzire and similar sedans offer smooth ride quality and efficient travel performance. Professional drivers ensure punctual pickups and safe driving to the airport. The sedan taxi is ideal for individual travelers and small families. Passengers enjoy air-conditioned comfort and convenient luggage space. The service ensures affordable and reliable airport transportation. Travelers experience comfortable and stress-free journeys."
}
],

tableData: [
["Navi Mumbai International Airport Cab","NMIA Airport Cab Service"],
["NMIA Taxi Service Navi Mumbai","Cab for NMIA Airport"],
["Taxi for NMIA Airport","NMIA Airport Pickup Cab"],
["NMIA Airport Drop Taxi","NMIA Airport Cab Booking"],
["NMIA Airport Taxi Booking Online","Cheap NMIA Airport Cab"],
["Best NMIA Airport Taxi Service","24x7 NMIA Airport Cab"],
["NMIA Airport Innova Cab","NMIA Airport Sedan Taxi"]
],


whychoose: [
  {
    WhyChooseheading: "Experienced Airport Drivers",
    WhyChoosedescription: "Our drivers are well experienced with Navi Mumbai International Airport routes, terminals, and nearby highways. They ensure smooth airport pickups and drop services without delays."
  },
  {
    WhyChooseheading: "Transparent Airport Cab Pricing",
    WhyChoosedescription: "Omshree Cabs provides transparent pricing for Navi Mumbai International Airport cab services. Customers receive clear information about fares, toll charges, and travel packages before confirming the booking."
  },
  {
    WhyChooseheading: "24/7 Airport Cab Availability",
    WhyChoosedescription: "Our Navi Mumbai International Airport cab service operates 24 hours a day. Whether your flight arrives early morning or late at night, our cabs are always available for reliable airport transportation."
  },
  {
    WhyChooseheading: "Clean & Comfortable AC Vehicles",
    WhyChoosedescription: "All vehicles in our fleet are fully air-conditioned, well maintained, and regularly cleaned to provide a comfortable airport travel experience."
  },
  {
    WhyChooseheading: "Flexible Pickup & Drop Options",
    WhyChoosedescription: "We offer flexible travel options including airport pickup, airport drop, one-way cabs, and round-trip bookings from Navi Mumbai International Airport."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "Omshree Cabs offers a variety of vehicles including sedan cars, SUVs like Ertiga and Innova, premium vehicles like Innova Crysta, and Tempo Travellers suitable for individuals, families, and group travelers."
  },
  {
    WhyChooseheading: "Doorstep Pickup Across Navi Mumbai",
    WhyChoosedescription: "We provide convenient pickup from homes, offices, hotels, railway stations, and business locations across Navi Mumbai for seamless airport transfers."
  },
  {
    WhyChooseheading: "Trusted Airport Cab Service",
    WhyChoosedescription: "Omshree Cabs is trusted by many travelers for Navi Mumbai International Airport transfers thanks to our punctual drivers, comfortable vehicles, and professional service."
  }
]
};

const faqData = [
  { question: "Do you provide cab service to Navi Mumbai International Airport?", answer: "Yes, Omshree Cabs provides reliable cab services for pickup and drop at Navi Mumbai International Airport." },
  { question: "Is the airport cab service available 24 hours?", answer: "Yes, our airport cab service operates 24/7 to match flight schedules." },
  { question: "Which vehicles are available for airport transfers?", answer: "We provide sedan cars, SUVs like Ertiga and Innova, premium vehicles like Innova Crysta, and Tempo Travellers." },
  { question: "Can I book a one-way airport drop?", answer: "Yes, we offer one-way airport pickup and drop services." },
  { question: "Do you provide pickup from homes and hotels?", answer: "Yes, our drivers provide doorstep pickup from homes, hotels, and offices across Navi Mumbai." },
  { question: "Are all vehicles air-conditioned?", answer: "Yes, all vehicles provided by Omshree Cabs are fully air-conditioned for comfortable travel." },
  { question: "Can I book airport cab service online?", answer: "Yes, customers can easily book airport cab services online or through phone booking." },
  { question: "Is advance booking recommended?", answer: "Yes, advance booking is recommended especially during peak travel hours and holidays." },
  { question: "Do you provide corporate airport transfers?", answer: "Yes, we provide airport transfer services for corporate travelers and business executives." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly to ensure passenger safety and hygiene." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Rohit Mehta",
    feedback:
      "Booked Omshree Cabs for Navi Mumbai International Airport pickup. The driver arrived on time and the journey was very comfortable.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Kavita Shah",
    feedback:
      "Excellent airport cab service. Clean vehicle, polite driver, and smooth travel experience.",
    rating: 5
  }
];








































const Images = [
  { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cab" },
{ place: "/images/keyword/2.jpeg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
{ place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
{ place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
{ place: "/images/keyword/5.jpeg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
{ place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
{ place: "/images/keyword/7.jpeg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
{ place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
{ place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
{ place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
{ place: "/images/keyword/11.jpeg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
{ place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
{ place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
{ place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
{ place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
{ place: "/images/keyword/16.jpeg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
{ place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
{ place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
{ place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
{ place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
{ place: "/images/keyword/21.jpeg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
{ place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
];











const jsonData = {
  "@context": "https://schema.org",
  "@type": "LocalBusiness",
  "name": "Omshree Cab",
  "description": "Omshree Cab provides reliable and affordable cabs for Navi Mumbai International Airport (NMIA). We offer airport pickups, drop-offs, one-way and round-trip taxi services with well-maintained vehicles including Innova and sedan cabs. Available 24x7 for business, leisure, and family travel.",
  "telephone": "+91 9892544084",
  "url": "https://www.omshreecab.com",
  "areaServed": {
    "@type": "City",
    "name": "Navi Mumbai, Maharashtra, India"
  },
  "serviceType": [
    "Navi Mumbai International Airport Cab",
    "Airport Pickup",
    "Airport Drop",
    "One Way Cab",
    "Round Trip Taxi",
    "Innova Cab",
    "Sedan Taxi",
    "24x7 Cab Service",
    "Luxury Cab"
  ]
};






  return (
    <div>
      
<Helmet>
  <title>Navi Mumbai International Airport Cab Service | Omshree Cab</title>
  <meta
    name="description"
    content="Book a cab to or from Navi Mumbai International Airport (NMIA) with Omshree Cab. We provide reliable 24x7 Innova and sedan cab services for airport pickups, drop-offs, one-way, and round trips."
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>


 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/98.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Omshree Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚙
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Omshree Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Omshree Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
       <div className="pc-contact">
      <h4 className="pc-title">Contact Information</h4>

      <div className="pc-grid">
        {/* Phones */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsTelephoneFill className="pc-icon" />
            <span>Phone Numbers</span>
          </header>

          <div className="pc-list">
            <a href="tel:+919892544084" className="pc-call">
              +91 9892544084
            </a>
          </div>

          <div className="pc-cta">
            <a
              href="https://wa.me/919892544084"
              target="_blank"
              rel="noopener noreferrer"
              className="pc-whats"
            >
              <BsWhatsapp /> WhatsApp
            </a>

            <a href="tel:+919892544084" className="pc-primary">
              Call Now
            </a>
          </div>
        </section>

        {/* Email */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsEnvelopeFill className="pc-icon" />
            <span>Email</span>
          </header>

          <a href="mailto:booking@omshreecabs.com" className="pc-email">
            booking@omshreecabs.com
          </a>
        </section>

        {/* Address */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsGeoAltFill className="pc-icon" />
            <span>Address</span>
          </header>

          <address className="pc-address">
            <strong>Omshree Cab</strong>
            <br />
           Shri Omkar Co-op Housing Society,
            <br />
            E-11/101, Sector 9,
Ghansoli (Gharonda),
            <br />
            Navi Mumbai, Maharashtra, India - 400701
          </address>
        </section>
      </div>
    </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Navimumbaiinternationalairportcab;